<template>
  <div class="article">
    <ul class="articleContentList">
      <li v-for="(item, i) in articlelist" :key="i">
        <a target="_blank" :href="item.url">
          <!-- 图片展示 -->
          <div class="img">
            <img :src="address + item.img" alt />
          </div>
          <!-- 时间 -->
          <div class="time">{{item.itemTime | dateFormat}}</div>
          <!-- 标题 -->
          <div class="title">{{item.content}}</div>
        </a>
      </li>
    </ul>
    <!-- 分页 -->
    <div class="pagingList">
      <el-pagination
        @current-change="handleCurrentChange"
        :page-size="queryInfo.size"
        :current-page="page"
        background
        layout="pager"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 查询参数对象
      queryInfo: {
        query: '',
        page: 0,
        size: 15,
        type: 10001,
        sort: 'sort,asc'
      },
      // 列表
      articlelist: {},
      // 总条数
      page: 1,
      total: 0,
      address: 'http://uploads.i-mineral.cn/'
    }
  },
  created() {
    this.getArticleList()
  },
  methods: {
    async getArticleList() {
      const { data: res } = await this.$http.get('/api/itemInfo', {
        params: this.queryInfo
      })
      if (res.content === null) {
        return this.$message.error('获取推文列表失败！')
      }
      this.articlelist = res.content
      this.total = res.totalElements
      console.log(this.articlelist)
    },
    handleCurrentChange(newPage) {
      this.queryInfo.page = newPage - 1
      this.getArticleList()
      this.page = newPage
    }
  }
}
</script>

<style scoped>
@media screen and (min-width: 850px) {
  .articleContentList {
    width: 100%;
    display: flex;
    justify-content: left;
    flex-wrap: wrap;
  }
}
@media screen and (max-width: 849px) {
  .articleContentList {
    width: 100%;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }
}
.articleContentList li {
  width: 320px;
  height: 110px;
  border: 1px solid rgb(220, 220, 220);
  margin: 10px;
  border-radius: 4px;
  overflow: hidden;
  box-sizing: border-box;
  background-color: #fff;
  position: relative;
}
.articleContentList li .img {
  position: absolute;
  width: 80px;
  height: 80px;
  top: 50%;
  left: 10px;
  transform: translate(0, -50%);
  border: 1px solid rgb(220, 220, 220);
  border-radius: 4px;
  overflow: hidden;
}
.articleContentList li .img img {
  width: 100%;
}
.articleContentList li .time {
  width: 180px;
  height: 20px;
  position: absolute;
  right: 10px;
  top: 20px;
  font-size: 14px;
  font-weight: 400;
  color: rgb(14, 5, 11);
}
.articleContentList li .title {
  width: 180px;
  height: 20px;
  position: absolute;
  right: 10px;
  top: 60px;
  font-size: 16px;
  font-weight: 400;
  color: #000;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
/* 分页 */
.pagingList {
  width: 100%;
  max-width: 1100px;
  margin: 20px auto;
  display: flex;
  justify-content: center;
}
</style>
